const styles = (theme) => ({
  root: {},
  gridItem: {
    display: 'flex',
    '&&': {
      paddingBottom: theme.spacing.unit * 2.5,
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing.unit * 3.5,
      },
    },
  },
});

export default styles;
